import { useState } from 'react';
import { Link, useSearchParams } from 'react-router';
import { ROUTES } from '@/app/router/routes';
import { Logo } from '@/components/brand/Logo';
import { ErrorNotice } from '@/components/portal/PortalPage';
import { Button } from '@/components/ui/Button';
import { TextField } from '@/components/ui/TextField';
import { authApi } from '../api/auth.api';
import { PasswordField } from '../components/PasswordField';

export const PasswordResetPage = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  return (
    <main className="min-h-dvh grid place-items-center p-5">
      <div className="portal-surface w-full max-w-lg p-7 sm:p-10">
        <Logo />
        <h1 className="mt-8 text-2xl font-semibold">
          {token ? 'Définir mon mot de passe' : 'Retrouver mon accès'}
        </h1>
        <p className="text-ink-500 mt-3 mb-6 text-sm leading-7">
          {token
            ? 'Activez votre accès à l’espace consultant ubeefy.'
            : 'Recevez un lien pour choisir un nouveau mot de passe.'}
        </p>
        {success ? (
          <p
            role="status"
            className="border-navy-100 bg-navy-50 rounded-lg border p-4 text-sm leading-7"
          >
            {success}
          </p>
        ) : (
          <form
            className="space-y-5"
            onSubmit={(event) => {
              event.preventDefault();
              setError('');
              if (pending) return;
              if (token && password !== confirmation) {
                setError('Les mots de passe doivent être identiques.');
                return;
              }
              setPending(true);
              const request = token
                ? authApi.resetPassword(token, password)
                : authApi.forgotPassword(email.trim().toLowerCase());
              void request
                .then((result) => {
                  setSuccess(result.message);
                  setPassword('');
                  setConfirmation('');
                })
                .catch((reason: unknown) =>
                  setError(
                    reason instanceof Error ? reason.message : 'La demande a échoué. Réessayez.',
                  ),
                )
                .finally(() => setPending(false));
            }}
          >
            {token ? (
              <>
                <PasswordField
                  label="Nouveau mot de passe"
                  autoComplete="new-password"
                  required
                  minLength={12}
                  maxLength={128}
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                />
                <p className="text-ink-500 text-xs leading-6">
                  12 caractères minimum, dont une majuscule, une minuscule et un chiffre.
                </p>
                <PasswordField
                  label="Confirmer le mot de passe"
                  autoComplete="new-password"
                  required
                  value={confirmation}
                  onChange={(event) => setConfirmation(event.target.value)}
                />
              </>
            ) : (
              <TextField
                label="Adresse e-mail"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            )}
            {error && <ErrorNotice>{error}</ErrorNotice>}
            <Button
              type="submit"
              className="w-full"
              loading={pending}
              loadingLabel="Enregistrement…"
            >
              {token ? 'Enregistrer mon mot de passe' : 'Recevoir le lien'}
            </Button>
          </form>
        )}
        <Link
          to={ROUTES.login}
          className="text-accent-700 mt-6 inline-block rounded text-sm hover:underline focus-visible:outline-2"
        >
          Revenir à la connexion
        </Link>
      </div>
    </main>
  );
};
